import React from 'react';
import { Fade } from 'react-reveal';
import { HashLink as Link } from 'react-router-hash-link';
import bannerGroup from '../../../assets/images/banner/banner-group.png'
import bannerGroup2 from '../../../assets/images/banner/banner-group2.png'
import bannerFrame from '../../../assets/images/icons/banner_frame.png'
import bannerFrame2 from '../../../assets/images/icons/banner_frame2.png'

const Home3Banner = () => {
    return (
        <>
            <section className="sc-banner-section-area3 sc-pt-130 sc-pb-50 ">
                <Fade top>
                    <div className="banner-circle-shape2 ">
                    </div>
                </Fade>
                <div className="container-fluid p-0">
                    <div className="row sc-banner-item d-flex align-items-center">
                        <div className="col-md-5">
                            <Fade bottom delay={100}>
                                <div className="banner-header-content" >
                                    <span className="sc-sub-title p-z-idex text-uppercase">COMPEON-Connect:</span>
                                    <h1 className="banner-title sc-mb-25 p-z-idex">Digitale Schnellkredite für Firmen-/ Gewerbekunden</h1>
                                    <div className="sc-mb-40">
                                    Jetzt als Bank von den schnellen und kosteneffizienten digitalen Prozessen in der gewerblichen Finanzierung profitieren
                                    </div>
                                    <form>
                                        <div className="sc-form-inner p-z-idex d-flex align-items-center justify-content-end">
                                            <div className="apps-form">
                                                <input type="email" id="email" name="email" placeholder="Email Address" required autoComplete="off" />
                                            </div>
                                            <div className="sc-primary-btn sc-md-pt-40">
                                            <Link className="third-transparent-btn" to="#"><span>Mehr erfahren</span></Link>
                                            </div>
                                        </div>
                                    </form>
                                     {/*<div className="banner-btn-area">
                                      <input type="email" id="email" name="email" placeholder="Ihre E-Mail-Adresse" required autoComplete="off" /> 
                                        <Link className="third-transparent-btn" to="/price#"><span>Mehr erfahren</span></Link>
                                    </div> */}
                                </div>
                            </Fade>
                        </div>
                        <div className="col-md-6">
                            <div className="banner_image shake-y ">
                                <Fade left delay={600}>
                                    <img className="banner-1" src={bannerGroup} alt="Banner" />
                                </Fade>
                                <Fade right delay={400}>
                                    <img className="banner-2" src={bannerGroup2} alt="Banner" />
                                </Fade>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="border-shape"></div>
                <div className="banner_frame d-none d-md-block">
                    <img className="frame_1" src={bannerFrame} alt="Frame" />
                </div>
            </section>
        </>
    );
};

export default Home3Banner;